import { Routes } from "@angular/router";

import { AuthGuard } from "./Core/guards/auth.guard";
// import { CanCheckoutGuard } from "./Core/guards/can-checkout.guard";
import { CategoriesComponent } from "./Global/categories/categories.component";
import { NotificationsComponent } from "./Global/notifications/notifications.component";
import { CartComponent } from "./Pages/Cart/Cart.component";
import { CompareProductComponent } from "./Pages/compare-product/compare-product.component";
import { FavoritesComponent } from "./Pages/favorites/favorites.component";
import { HomeTwoComponent } from "./Pages/Home/HomeTwo/HomeTwo.component";
import { NotFoundComponent } from "./Pages/NotFound/NotFound.component";
import { UnderConstructionComponent } from "./Pages/UnderConstruction/UnderConstruction.component";
import { NotAvailableComponent } from "./Pages/not-available/not-available.component";
import { BrandImagesComponent } from "./Global/brand-images/brand-images.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { TermsAndConditionsComponent } from "./terms-and-conditions/terms-and-conditions.component";
import { CookiePolicyComponent } from "./cookie-policy/cookie-policy.component";
import { PrescriptionGuard } from "./Core/guards/prescription.guard";
import { ProductsListComponent } from "./Pages/Products/ProductsList/ProductsList.component";
import { DetailPageComponent } from "./Pages/Products/DetailPage/DetailPage.component";
import { BrandsComponent } from "./Global/brands/brands.component";
import { CategoryViewComponent } from "./Global/category-view/category-view.component";
import { AllCategoriesComponent } from "./Global/all-categories/all-categories.component";
import { VendorsComponent } from "./Global/vendors/vendors.component";

import { AddAddressPageComponent } from "./Pages/prescriptions/add-address-page/add-address-page.component";
import { PdfPreviewerComponent } from "./Pages/pdf-previewer/pdf-previewer.component";
import { BlogComponent } from "./Pages/blog/blog.component";
import { BlogDetailsComponent } from "./Pages/blog-details/blog-details.component";

const lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : 'en';

export const AppRoutes: Routes = [
    { path: "", redirectTo: lang?.toLocaleLowerCase(), pathMatch: "full" },
    {
        path: ":lang",
        children: [
            {
                path: "",
                component: HomeTwoComponent,
            },
            {
                path: "add-address",
                component: AddAddressPageComponent,
            },
            {
                path: "verify-phone",
                loadChildren: () =>
                    import(
                        "./Global/components/verify-phone/verify-phone/verify-phone.module"
                    ).then((m) => m.VerifyPhoneModule),
            },
            { path: "pdf/:slug", component: PdfPreviewerComponent },
            { path: "blog", component: BlogComponent },
            { path: "blog/:slug", component: BlogDetailsComponent },
            {
                path: "categories",
                component: CategoriesComponent,
            },
            {
                path: "category-view",
                component: CategoryViewComponent,
            },
        
            {
                path: "category/:categorySlug/:groupSlug",
                component: CategoryViewComponent,
            },
                {
                path: "category/:categorySlug",
                component: CategoryViewComponent,
            },
              {
                path: "category",
                component: CategoryViewComponent,
            },
            {
                path: "all-categories",
                component: AllCategoriesComponent,
            },
            {
                path: "vendors",
                component: VendorsComponent,
            },
            {
                path: "brands",
                component: BrandsComponent,
            },
            {
                path: "privacy-policy",
                component: PrivacyPolicyComponent,
            },
            {
                path: "terms-and-conditions",
                component: TermsAndConditionsComponent,
            },
            {
                path: "cookie-policy",
                component: CookiePolicyComponent,
            },
            {
                path: "products",
                component: ProductsListComponent,
            },
            {
                path: "products/deals",
                component: ProductsListComponent,
            },
            {
                path: "products/deals/:name",
                component: ProductsListComponent,
            },
            {
                path: 'product/:categorySlug/:groupSlug/:subCategorySlug',
                component: ProductsListComponent
            },
            {
                path: 'product/:categorySlug/:groupSlug',
                component: ProductsListComponent
            },
            {
                path: 'product/:categorySlug',
                component: ProductsListComponent
            },
            {
                path: "products/:name",
                component: DetailPageComponent,
            },
            {
                path: "products/:name/:id",
                component: DetailPageComponent,
            },
            {
                path: "products/deals/:name/:id",
                component: DetailPageComponent,
            },
        
            {
                path: "cart",
                component: CartComponent,
                 pathMatch: 'full'
            },
            {
                path: "favorites",
                component: FavoritesComponent,
            },
            {
                path: "brand/:id",
                component: BrandImagesComponent,
            },
            {
                path: "compare",
                component: CompareProductComponent,
            },
            {
                path: "notifications",
                component: NotificationsComponent,
            },
            {
                path: "not-found",
                component: NotFoundComponent,
            },
            {
                path: "not-available",
                component: NotAvailableComponent,
            },

            {
                path: "under-construction",
                component: UnderConstructionComponent,
            },
            {
                path: "session",
                loadChildren: () =>
                    import("./Pages/Session/Session.module").then(
                        (m) => m.SessionModule
                    ),
            },
            {
                path: "checkout",
                loadChildren: () =>
                    import("./Pages/Checkout/Checkout.module").then(
                        (m) => m.CheckoutModule
                    ),
            },
            {
                path: "pages",
                loadChildren: () =>
                    import("./Pages/About/About.module").then(
                        (m) => m.AboutModule
                    ),
            },
            {
                path: "forms",
                loadChildren: () =>
                    import("./Pages/forms/forms.module").then(
                        (m) => m.DynamicFormsModule
                    ),
            },
            {
                path: "account",
                loadChildren: () =>
                    import("./Pages/UserAccount/UserAccount.module").then(
                        (m) => m.UserAccountModule
                    ),
            },
            {
                path: "orders",
                loadChildren: () =>
                    import("./Pages/UserAccount/UserAccount.module").then(
                        (m) => m.UserAccountModule
                    ),
            },
      
            {
                path: "prescriptions",
                loadChildren: () =>
                    import("./Pages/prescriptions/prescriptions.module").then(
                        (m) => m.PrescriptionsModule
                    ),
                canActivate: [AuthGuard, PrescriptionGuard],
            },
          
            {
                path: ":name",
                component: DetailPageComponent,
                 pathMatch: 'full'
            },
      
            {
                path: "**",
                redirectTo: "not-found",
            },

        ],
    },

];
